import { UGCListSubBlock, UGCPost } from "../models/ugc";

/** List item whose snippet resolved to a post (a renderable grid/carousel cell). */
export type UGCTileWithPost = UGCListSubBlock & {
    readonly post: UGCPost;
};

/**
 * Compact to renderable cells. Indexes into this array are the only valid
 * space for UGCGallery `initialSlide`, Flickity cell indexes, and `inert`
 * selection — do not mix with unfiltered `props.tiles` indexes.
 */
export const filterUGCTilesWithPosts = (
    tiles: readonly UGCListSubBlock[] | null | undefined,
): UGCTileWithPost[] => {
    if (!tiles) {
        return [];
    }
    return tiles.filter((tile): tile is UGCTileWithPost => tile.post != null);
};
